import script from "./EditorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorPanel.vue?vue&type=script&setup=true&lang=js"

import "./EditorPanel.vue?vue&type=style&index=0&id=6b5bf7f8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5bf7f8"]])

export default __exports__